'use client';

import { useEffect } from 'react';
import { addNextjsError } from '@datadog/browser-rum-nextjs';

export default function Error({ error, reset }) {
  useEffect(() => {
    addNextjsError(error);
  }, [error]);

  return (
    <div className="container mx-auto px-4 py-24 text-center">
      <h1 className="font-cormorant text-4xl text-primary mb-4">
        Something went wrong
      </h1>
      <p className="font-worksans text-base text-black mb-8">
        We&apos;re sorry, an unexpected error occurred. Please try again.
      </p>
      <button
        onClick={reset}
        className="px-6 py-3 bg-sea text-white rounded-full font-worksans text-base"
      >
        Try again
      </button>
    </div>
  );
}
